import styled from "styled-components";

const ligthGrayColor = "#808495"

export const ContainerUac = styled.section`
    display: flex;
    flex-direction: column;
    p {
        color: #272727;
        font-weight: 400;
        font-size: 1rem;
    }
	h2 {
        color: #272727;
        font-size: 1rem;
    }
`;

export const Container = styled.div`
	
	margin-top: 15px;
	border-radius: 15px;
	height: 166.78px;
    width: 100%;
    max-width: 577.9px;


	display: grid;
    grid-template-columns: 60px minmax(auto, 412px);
	justify-content: center;
    column-gap: 26px;
    
	div {
		p {
			color: ${({ theme }) => theme.colors.darkBlue};
			margin-bottom: 9px;
			font-size: 1.375rem;
			@media (max-width: 768px) {
				font-size: 18px;
			}
		}
	}


	@media (max-width: 768px){
		margin-top: 18.26px;
		grid-template-columns: 1fr;
		justify-items: center;
		height: 236.78px;
  	}

`;

export const Content = styled.div`

	div {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		font-size: 1.125rem;
		
		p {
			color: ${({theme}) => theme.colors.blueColor};
			font-size: 1.125rem;
		}

		a {
			text-decoration: none;
			color: ${ligthGrayColor};
		}

		@media (max-width: 768px){
			font-size: 1.125rem;
			text-align: center;
  		}
	}

`;

export const IconContact = styled.div`
	height: 60px;
	width: 60px;
	border: 4px solid ${({theme}) => theme.colors.darkYellow};
	border-radius: 50%;
	color: ${({theme}) => theme.colors.darkYellow};
	padding: 4px;
	display: flex;
	place-items: center;
	place-content: center;
`;

